/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetExportedFilesRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {GetExportedFilesResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const getExportedFiles = (request: GetExportedFilesRequest, options?: CashRequestOptions) => post<GetExportedFilesRequest, GetExportedFilesResponse>("/2.0/cash/get-exported-files", request, {...options, rejectOnError: true })